// DEMAND FORECASTER
export const FORECAST_DEMAND_LIST_SUCCESS = 'FORECAST_DEMAND_LIST_SUCCESS';
export const EDIT_FORECAST_DEMAND = 'EDIT_FORECAST_DEMAND';
export const EVENT_OCCURRENCE_LIST_SUCCESS = 'EVENT_OCCURRENCE_LIST_SUCCESS';
